import { keyBy } from 'lodash'
import { POST } from '@/api'

export default {
  namespaced: true,
  state: {
    byId: {},
    allIds: [],
    busy: false,
  },
  mutations: {
    set(state, courses = []) {
      courses = [{ id: -1, names: { ja: '選択しない', en: 'not select' }, count: 1, price: 0 }, ...courses]
      state.byId = keyBy(courses, 'id')
      state.allIds = courses.map(({ id }) => id)
    },
    busy(state, busy = false) {
      state.busy = busy
    },
  },
  getters: {
    all({ byId, allIds }) {
      return allIds.map(id => byId[id])
    },
  },
  actions: {
    async get({ commit, rootState }) {
      commit('busy', true)

      const { status, message, data } = await POST(`/${rootState.reception.segment}/api/web/course/search`)

      if (status === 200) {
        commit(
          'set',
          data.course.map(course => ({
            ...course,
            names: {
              ja: course.names.jpn,
              en: course.names.eng,
            },
          })),
        )
      } else {
        commit('error/message', message, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
